export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/personal_stylists.3f5b097.svg";